const countyConfigLoginRegistrationReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_LOGIN_REGISTRATION':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigLoginRegistrationReducer;